<div
  [class]="elementSelectors.css.root"
  [class.opened]="opened()"
  [class.interacted]="interacted"
  [class.d-none]="!visible()"
  [style.margin-bottom.px]="bottomMargin()">
  <div
    [class]="elementSelectors.css.title"
    class="row m-0 align-items-center bg-primary">
    <span
      class="col-auto pl-2 ml-1 pr-2 cursor-pointer"
      (click)="toggle()"
      >{{ 'shared:feedback.widget.title' | i18next }}</span
    >
    <mbs-button
      type="dark"
      class="col-1"
      [size]="mbsSize.sm"
      [isCtrl]="true"
      [icon]="'ico ico-Close'"
      (click)="remindMeLater(30)"></mbs-button>
  </div>
  <div
    [class]="elementSelectors.css.padding"
    class="bg-primary">
    <!-- subpixel problem -->
  </div>
  <div
    [class]="elementSelectors.css.body"
    class="d-flex background-secondary">
    <div class="feedback-widget_body-top-line bg-primary"></div>
    <div
      [class]="elementSelectors.css.content"
      class="row mx-0 align-items-center">
      <div class="col">
        <div class="row mt-4 justify-content-center">{{ 'shared:feedback.widget.subtitle' | i18next }}</div>
        <div
          [class]="elementSelectors.css.stars"
          class="row mx-0 my-3 justify-content-center"
          [style.--star-size.px]="starSize"
          [style.--star-gap.px]="starGap"
          (mouseleave)="clearHovered()">
          <div class="col-1"><!-- left empty div --></div>
          <ng-container *ngFor="let star of [1, 2, 3, 4, 5]">
            <div
              class="feedback-widget_body-star col-2 px-0"
              (mousemove)="setHovered(star - ($event.offsetX < halfStarSize ? 0.5 : 0))"
              (click)="rate(star - ($event.offsetX < halfStarSize ? 0.5 : 0))">
              <ng-container [ngSwitch]="getStarFill(star)">
                <span
                  [class]="elementSelectors.css.icon"
                  class="full"
                  *ngSwitchCase="'full'"
                  >★</span
                >
                <span
                  [class]="elementSelectors.css.icon"
                  class="half"
                  *ngSwitchCase="'half'"
                  >★</span
                >
                <span
                  [class]="elementSelectors.css.icon"
                  class="empty"
                  *ngSwitchCase="'empty'"
                  >★</span
                >
              </ng-container>
            </div>
          </ng-container>
          <div class="col-1"><!-- right empty div --></div>
        </div>
        <div
          class="row justify-content-center"
          [formGroup]="form">
          <mbs-input
            mbsSizeObserver
            (sizeChanged)="textareaSize.set($event)"
            type="textarea"
            [class]="elementSelectors.css.textarea"
            [rows]="5"
            [maxLength]="1000"
            [maxHeight]="'50vh'"
            [resize]="'vertical'"
            [placeholder]="'shared:feedback.widget.placeholder' | i18next"
            [formControlName]="'description'"></mbs-input>
        </div>
        <div class="row mt-3 justify-content-center">
          <div class="col">
            <mbs-button
              [isCtrl]="true"
              class="w-100"
              customClasses="w-100"
              (click)="handleEarnMoneyClick()">
              <div
                class="feedback-widget_body-earn-banner d-flex flex-row flex-fill align-items-center justify-content-between px-2 w-100 text-gray-900">
                <div>
                  <span class="px-2"
                    ><img
                      [src]="'assets/images/storages-tree/StorageGroupPicture.svg'"
                      class="earn-icon"
                      alt="Money icon"
                  /></span>
                  <span class="fw-semibold">{{ 'shared:feedback.widget.earnText1' | i18next }}</span>
                  <span class="fw-semibold text-orange">&nbsp;{{ 'shared:feedback.widget.earnText2' | i18next }}&nbsp;</span>
                  <span class="fw-semibold">{{ 'shared:feedback.widget.earnText3' | i18next }}</span>
                </div>
                <div>
                  <span class="pl-2"
                    ><img
                      [src]="'assets/images/feedback-earn-arrow.svg'"
                      class="pl-1"
                      alt="Feedback earn arrow"
                  /></span>
                </div>
              </div>
            </mbs-button>
          </div>
        </div>
        <div class="row mt-3 pt-3 mb-3 justify-content-end">
          <mbs-button
            class="feedback-widget_body-remindMeLater col justify-content-end"
            [type]="'link'"
            [loading]="loading"
            (click)="remindMeLater(3)">
            {{ 'shared:feedback.widget.remindMeLater' | i18next }}
          </mbs-button>
          <mbs-button
            class="col-auto"
            [type]="'primary'"
            [loading]="loading"
            [disabled]="!ratingSelected"
            (click)="send()">
            {{ 'shared:feedback.widget.send' | i18next }}
          </mbs-button>
        </div>
      </div>
    </div>
  </div>
</div>
